import React, {Component} from 'react';
import {reduxForm, Field, reset} from 'redux-form';

import {checkRequiredFields} from "forms";
import {generateId} from "../../store/auth/utils";
import {increaseLocalIncrement} from "store/auth/actions";
import {addCard, putCards} from "store/cards/actions";
import {trimValues} from "utils";
import RaisedButton from 'material-ui/RaisedButton';
import {TextField,} from 'redux-form-material-ui';
import {Row, Col} from "components/flexbox-grid";
import "./CardAddBar.css"
import {FontIcon} from "material-ui";
import {nativeWordDuplicity, foreignWordDuplicity, capitalizeFirstLetter} from "utils";
import {translate} from "react-i18next";
import $ from 'jquery'

function KeyboardHint({showHint}) {
    if (!showHint) {
        return null;
    }
    return (
            <Row>
                <Col small={12}>
                    <p style={{fontSize: '15px'}}>
                        <span style={{color: 'rgb(224, 224, 224)'}}>TIP: </span>
                        <span style={{color: 'rgb(128, 128, 128)'}}>Use <img src={"/icons/tab@2x.png"} width={"10"} style={{marginLeft: '3px'}} /> TAB to switch inputs and <img src={"/icons/enter@2x.png"} width={"10"} style={{marginLeft: '3px'}} /> ENTER to save it.</span>
                    </p>
                </Col>
            </Row>
        )
}

class CardForm extends Component {

    state = {
        showHint: false
    }

    saveRef = ref => (this.firstInputRef = ref);

    onAddCardBtnClick = (event) => {
        this.setState({showHint: event.detail >= 1})
    }

    render() {
        return (
            <form onSubmit={this.props.handleSubmit(this.props.onSubmit)}>
                <Row>
                    <Col large={3} small={12}>
                        <Field autoFocus onPaste={this.props.onFirstFieldPaste} maxLength={100} className={"field"} name="f_word" component={TextField} hintText={this.props.foreignLang ? capitalizeFirstLetter(this.props.foreignLang.native_name) : ""} style={{marginLeft: '10px'}} ref={this.saveRef} withRef/>
                    </Col>
                    <Col large={3} small={12}>
                        <Field maxLength={100} className={"field"} name="n_word" component={TextField} hintText={this.props.nativeLang ? capitalizeFirstLetter(this.props.nativeLang.native_name) : ""} style={{marginLeft: '5px'}}/>
                    </Col>
                    <Col large={3} small={12}>
                        <Field maxLength={300} className={"field"} name="example" component={TextField} hintText={this.props.t('package_management_example_sentence')} style={{marginLeft: '15px'}}/>
                    </Col>
                    <Col large={3} small={12}>
                        <RaisedButton
                            className={"button"}
                            style={{verticalAlign: 'top', marginTop: '10px', marginLeft: '20px'}}
                            icon={<FontIcon style={{color: 'white'}} className="material-icons">keyboard_return</FontIcon>}
                            type="submit"
                            label={this.props.t('package_management_add_card')}
                            primary={true}
                            keyboardFocused={false}
                            key="submit"
                            onClick={this.onAddCardBtnClick}
                        />
                    </Col>
                </Row>
                <KeyboardHint showHint={this.state.showHint}/>
            </form>
        )
    }

}

CardForm = reduxForm({
    form: 'cardForm',
})(translate('translations', {withRef: true})(CardForm));


class CardAddBar extends Component {

    state = {
        sticky: false
    }

    saveFormRef = ref => {
        this.formRef = ref;
    };

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
        this.handleScroll();
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }

    handleScroll = () => {
        if ($(window).scrollTop() + $(window).height() >= $(document).height()) {
            this.setState({sticky: false})
        }
        else {
            this.setState({sticky: true})
        }
    };


    render() {
        const basicStyle = {
            // display: 'inline-block',
            position: 'sticky',
            bottom: 0,
            verticalAlign: 'top',
            marginTop: '20px',
            padding: '10px',
            backgroundColor: 'white',

        };
        let style = null;
        if (this.state.sticky === true) {
            style = {
                ...basicStyle,
                boxShadow: '0px -3px 50px -20px rgba(0,0,0,0.75)',
                marginRight: '-40px',
                marginLeft: '-40px',
                paddingLeft: '50px',
                paddingRight: '50px',

            }
        }
        else {
            style = {
                ...basicStyle,
                paddingLeft: '10px',
                paddingRight: '10px',
                // boxShadow: '0px 0px 50px -10px rgba(0, 0, 0, 0.3)'
            }
        }

        return (
            <div className={"cardAddBar"} style={style}>
                <CardForm onFirstFieldPaste={this.props.onFirstFieldPaste} package={this.props.package} nativeLang={this.props.nativeLang} foreignLang={this.props.foreignLang} ref={this.saveFormRef} onSubmit={this.submitForm}/>
            </div>
        )
    }

    sendForm = (values) => {
        values = trimValues(values);
        checkRequiredFields(['n_word', 'f_word'], values);
        return (dispatch, getState) => {
            const state = getState();
            const nWordDuplicity = nativeWordDuplicity(values.n_word, this.props.cards);
            const fWordDuplicity = foreignWordDuplicity(values.f_word, this.props.cards);
            let confirmMessage = null;
            if (nWordDuplicity) {
                confirmMessage = this.props.t('package_management_word_already_with_translation', {1: values.n_word, 2: nWordDuplicity.f_word});
                // confirmMessage = `${this.state.nativeLang.name} word "${values.n_word}" already exists with translation "${nWordDuplicity.f_word}", do you really want to add it?`;
            }
            if (fWordDuplicity) {
                confirmMessage = this.props.t('package_management_word_already_with_translation', {1: values.f_word, 2: fWordDuplicity.n_word});
                // confirmMessage = `${this.state.foreignLang.name} word "${values.f_word}" already exists with translation "${fWordDuplicity.n_word}", do you really want to add it?`;
            }
            if (!(nWordDuplicity || fWordDuplicity) || window.confirm(confirmMessage)) {
                const id = generateId(state.auth.deviceId, state.auth.localIncrement);
                const card = {...values, id, package_id: this.props.package.id};
                dispatch(increaseLocalIncrement());
                dispatch(addCard(card));
                const f_word = document.querySelector(`[name="f_word"]`);
                f_word.focus();
                dispatch(reset('cardForm'));
                dispatch(putCards());
                this.props.onCardAdded(card);

            }
            else {
                dispatch(reset('cardForm'));
            }
        }

    };

    submitForm = (values, dispatch) => {
        return dispatch(this.sendForm(values))
    }
}


export default translate('translations', {withRef: true})(CardAddBar);



// WEBPACK FOOTER //
// ./src/components/packages/CardAddBar.js